import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const tableStyle = {
  backgroundColor: '#ffffff',
  marginBottom: '70px',
}

const divStyle = {
  paddingTop: '30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
  }

  renderHeader() {
    return <Fragment><th key="name">Name</th><th key="dateevery">Date(day/month)</th><th key="actions">Actions</th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.publicholidays.everyyear)).sort((a, b) => { if (a.month === b.month) { return a.day - b.day } return a.month - b.month })
    return Object.keys(myData).map((key) => {
      const ph = myData[key]
      //console.log(ph)
      return <tr key={key}><td>{ph['name']}</td><td>{ph['day']}/{ph['month']}</td><td><span><a href="#" onClick={() => this.handleSubmit(ph['id'])} style={linkStyle}>Delete</a></span></td></tr>
    }
    )
  }

  renderHeaderOnce() {
    return <Fragment><th key="nameonce">Name</th><th key="dateonce">Date(day/month/year)</th><th key="actionsonce">Actions</th></Fragment>
  }

  renderDataOnce() {
    const myData = [].concat(Object.values(this.props.publicholidays.once)).sort((a, b) => { if (a.year === b.year && a.month === b.month) { return a.day - b.day } if (a.year === b.year) { return a.month - b.month } return b.year - a.year })
    return Object.keys(myData).map((key) => {
      const ph = myData[key]
      //console.log(ph)
      return <tr key={key}><td>{ph['name']}</td><td>{ph['day']}/{ph['month']}/{ph['year']}</td><td><span><a href="#" onClick={() => this.handleSubmit(ph['id'])} style={linkStyle}>Delete</a></span></td></tr>
    }
    )
  }

  render() {
    const li = '/delete_public_holidays/' + this.props.publicholidays.user.id
    return <div><a href={li} id="mylink" style={aStyle}></a><h3 className="align-items-right">Public holidays every year</h3><div className="row justify-content-center align-items-center" style={divStyle}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div><h3>Public holidays once a year</h3><div className="row justify-content-center align-items-center" style={divStyle}><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderOnce()}</tr>{this.renderDataOnce()}</tbody></table></div></div>
  }

  handleSubmit(idU) {
    let urlf = '/api/v1/public_holidays/'
    urlf = urlf + idU.toString()
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure to delete this public holiday?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            fetch(urlf, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.json())
            .then((data) => {
              if (data.type === 'success'){
                document.getElementById('mylink').click()
              } else {
                console.error('err' + data)
              }
            })
            .catch((err) => {
              console.error('Error while deleting public holiday! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }
}

Table.propTypes = {
  publicholidays: PropTypes.object,
}

export default Table
